import axios from '@/plugins/axios.js';

export default {
    state: {
        $echo: null,
        online: {},
        ready: null,
    },

    actions: {
        async createWebsocketConnection({ state, commit }, $echo) {
            commit('SET_CONNECTION', $echo);

            axios.interceptors.request.use(request => {
                request.headers['X-Socket-Id'] = $echo.socketId();

                return request;
            });

            if (typeof state.ready === 'function') {
                state.ready();
            }
        },
    },

    mutations: {
        SET_CONNECTION(state, $echo) {
            state.$echo = $echo;
        },

        ADD_ONLINE_USER(state, user) {
            state.online[user.id] = user;
        },

        REMOVE_ONLINE_USER(state, userId) {
            delete state.online[userId];
        },

        SYNC_ONLINE_USERS(state, users) {
            Object.keys(state.online)?.forEach(userId => {
                if (!users?.includes(userId)) {
                    delete state.online[userId];
                }
            });

            users?.forEach(userId => {
                state.online[userId] = true;
            });
        },

        SET_READY_LISTENER(state, listener) {
            state.ready = listener;
        },
    },
};
